// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-welcome {
  text-align: center;
  background-color: #002E33;
  color: #FFF;
  width: 100vw;
  height: 100%;
  padding-top: 5em;
  z-index: 999;
  bottom: 0;
  top: 0;
  position: absolute;
}
.mobile-welcome .header {
  width: 70%;
  margin: auto;
}
.mobile-welcome .header p {
  font-size: 1.2em;
}
.mobile-welcome .header h2 {
  font-size: 2em;
  font-weight: 300;
  line-height: 1.5em;
}
.mobile-welcome .button-wrapper {
  display: block;
}
.mobile-welcome .button-wrapper a {
  cursor: pointer;
  border-radius: 0.25em;
  background-color: #002E33;
  width: 50%;
  margin: 15px auto;
  margin-top: 0;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.mobile-welcome .button-wrapper .logout {
  background-color: #002E33;
}
.mobile-welcome .button-wrapper .continue {
  background: transparent;
}
.mobile-welcome .button-wrapper .optimizedFor {
  font-size: 1.2em;
}
.mobile-welcome .button-wrapper .optimizedFor .continue {
  color: #FFF;
}
.mobile-welcome .footer {
  width: 70%;
  margin: auto;
  padding-top: 4em;
  font-size: 1em;
  line-height: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/client/components/MobileWelcome.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,yBCFa;EDGb,WCGM;EDFN,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;AADF;AAGE;EACE,UAAA;EACA,YAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAII;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAFN;AAME;EACI,cAAA;AAJN;AAMM;EACE,eAAA;EACA,qBAAA;EACA,yBCjCO;EDkCP,UAAA;EACA,iBAAA;EACA,aAAA;EACA,kCAAA;EAAA,0BAAA;AAJR;AAOM;EACE,yBCzCO;ADoCf;AAQM;EACE,uBAAA;AANR;AASM;EACE,gBAAA;AAPR;AASM;EACE,WC9CA;ADuCR;AAYE;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAVJ","sourcesContent":["@import '../Global/Colors';\n\n.mobile-welcome {\n  text-align: center;\n  background-color: $DeepSeaGreen;\n  color: $White;\n  width: 100vw;\n  height: 100%;\n  padding-top: 5em;\n  z-index: 999;\n  bottom: 0;\n  top: 0;\n  position: absolute;\n\n  .header {\n    width: 70%;\n    margin: auto;\n\n    p {\n      font-size: 1.2em;\n    }\n\n    h2 {\n      font-size: 2em;\n      font-weight: 300;\n      line-height: 1.5em;\n    }\n  }\n\n  .button-wrapper {\n      display: block;\n\n      a {\n        cursor: pointer;\n        border-radius: 0.25em;\n        background-color: $DeepSeaGreen;\n        width: 50%;\n        margin: 15px auto;\n        margin-top: 0;\n        text-decoration: underline;\n      }\n\n      .logout {\n        background-color: $DeepSeaGreen;\n      }\n\n      .continue {\n        background: transparent;\n      }\n\n      .optimizedFor {\n        font-size: 1.2em;\n\n      .continue {\n        color: $White;\n      }\n    }\n  }\n\n  .footer {\n    width: 70%;\n    margin: auto;\n    padding-top: 4em;\n    font-size: 1em;\n    line-height: 1.5em;\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
